module.exports = __webpack_public_path__ + "img/24a-consultas-pagamentos-show.f55f9bd2.png";